<template>
  <div class="pageWidth">
    <div class="hbb_headerBox">
      <div @click="goHome">
        <img class="logoImg" src="@assets/images/pic_logo.png" alt />
      </div>
      <div class="hbb_h_r">
        <div class="hbb_headerOpt">
          <span @click="AddFavorite()">加入收藏</span>
          <!-- <span @click="toDesktop()">加入桌面</span> -->
        </div>
        <div>
          当前用户：{{ userInfo.realName }}({{ userInfo.mobile }})
          <span style="margin-left: 20px; color: #377de8" @click="goOut"
            >退出</span
          >
        </div>
      </div>
    </div>
    <!-- 意见反馈 -->
    <div class="sdw_feedback_container" @click="on_feedback_click">
      <img src="@assets/images/icon_feedbackLink.png" class="sdw_one" />
      <img src="@assets/images/icon_feedbackHover.png" class="sdw_two" />
      <span>意见反馈</span>
    </div>

    <el-dialog
      title="意见反馈"
      custom-class="sdw_feedback_dialog"
      :visible.sync="feedback_launched"
      :close-on-click-modal="false"
    >
      <el-form>
        <span>
          <b>详细说明</b
          >（请您详细说明遇到的情况，以保证管理员及时准确判断并处理您的反馈。若信息不全或不明确，管理员将很难做出判断。500个汉字以内）
        </span>
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入内容"
          maxlength="500"
          v-model="feedback_content"
          show-word-limit
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="on_feedback_close">取 消</el-button>
        <el-button type="primary" @click="on_feedback_submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import server from "@/utils/server";
export default {
  props: {
    userInfo: Object, //当前用户,
  },
  data() {
    return {
      uploadDomian: process.env.VUE_APP_UPLOAD_DOMAIN, // 不同环境走不同的地址 [仅供上传]
      apiDomian: process.env.VUE_APP_API_DOMAIN, // 本站地址
      // userInfo: {}, //当前用户,
      feedback_launched: false, //反馈弹层是否启动
      feedback_content: "", //反馈弹层内容
    };
  },
  created() {
    // server.myAxios("/api/UserCenter/GetUser").then((res) => {
    //   this.userInfo = res;
    // });
  },
  mounted() {
    this.getPositionFeedback();
  },
  methods: {
    getPositionFeedback() {
      // 动态获取意见反馈的位置
      let windowWidth = $(window).width();
      let divWidth = $(".sdw_feedback_container").width();
      let divRight = (windowWidth - 1200) / 2 - divWidth - 6;
      $(".sdw_feedback_container").css({ right: divRight + "px" });
      $(".sdw_feedback_container").hover(
        function () {
          $(this).find(".sdw_one").hide();
          $(this).find(".sdw_two").show();
        },
        function () {
          $(this).find(".sdw_one").show();
          $(this).find(".sdw_two").hide();
        }
      );
    },
    AddFavorite() {
      //收藏本站
      let url = window.location.href;
      let title = "我的网站";
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        try {
          window.sidebar.addPanel(title, url, "");
        } catch (e) {
          alert(
            "抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加"
          );
        }
      }
    },
    toDesktop() {
      //保存到桌面
      let sUrl = window.location.href;
      let sName = "我的网站";
      try {
        var WshShell = new ActiveXObject("WScript.Shell");
        var oUrlLink = WshShell.CreateShortcut(
          WshShell.SpecialFolders("Desktop") + "\\" + sName + ".url"
        );
        oUrlLink.TargetPath = sUrl;
        oUrlLink.Save();
      } catch (e) {
        alert("当前IE安全级别不允许操作！");
      }
    },
    goHome() {
      // 去首页

      this.$router.push({
        path: "/",
      });
      setTimeout(() => {
        location.reload();
      }, 0);
    },
    goOut() {
      // 退出登录
      window.open(this.uploadDomian, "_self");
    },

    on_feedback_click() {
      this.feedback_content = "";
      this.feedback_launched = true;
    },
    on_feedback_close() {
      this.feedback_launched = false;
    },
    on_feedback_submit() {
      server
        .myAxios("/api/Common/Feedback", { feedContent: this.feedback_content })
        .then((res) => {
          this.$message({
            type: "success",
            message: "提交成功",
          });
          this.feedback_launched = false;
        });
    },
  },
};
</script>

<style>
.hbb_headerBox {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
}
.hbb_headerOpt {
  margin-right: 20px;
  font-size: 12px;
  border-right: 1px solid #ddd;
  padding-right: 20px;
}
.hbb_headerOpt span {
  margin-left: 20px;
}
.hbb_h_r {
  display: flex;
  font-size: 12px;
  cursor: pointer;
}
.logoImg {
  width: 150px;
}

.sdw_feedback_container {
  display: flex;
  width: 42px;
  height: 120px;
  color: white;
  background: #fff;
  position: fixed;
  z-index: 1;
  right: 0;
  top: 75%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
.sdw_feedback_container img {
  width: 20px;
}
.sdw_two {
  display: none;
}
.sdw_feedback_container span {
  width: 20px;
  padding-top: 3px;
  font-size: 14px;
  text-align: center;
  color: #000;
}
.sdw_feedback_container:hover span {
  color: #e74c3c;
}
.sdw_feedback_dialog .el-dialog__body span {
  line-height: 20px;
  color: #5b5b5b;
}
.sdw_feedback_dialog .el-dialog__body span b {
  color: #282828;
}
.sdw_feedback_dialog .el-dialog__body .el-textarea {
  padding-top: 6px;
}
.sdw_feedback_dialog .el-dialog__body .el-textarea .el-textarea__inner {
  padding: 6px;
  font-size: 13px;
  line-height: 24px;
  color: 282828;
  resize: none;
  font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC",
    "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei",
    sans-serif;
}

.sdw-sliderverification-dialog .el-dialog__body {
  padding: 0 0 0 0;
}
</style>